import { httpClient } from '@/shared/api/httpClient';
import { classifyApiError } from '@/shared/api/classifyApiError';
import type { EmployeeLookupDTO, EmployeeListResponseDTO } from '../dto/TimelogDTO';
import { toAttendanceEmployee, type AttendanceEmployee } from '../mappers/timelogMapper';

export class RemoteEmployeeLookupRepository {
  async findByCodeOrDui(
    accessRoleId: number,
    searchValue: string,
  ): Promise<AttendanceEmployee | null> {
    try {
      const res = await httpClient.get<EmployeeListResponseDTO>(
        `/v1/clock/app/${accessRoleId}/employees`,
      );
      const v = searchValue.toLowerCase().trim();
      const match = res.data.data.results.find(
        (e: EmployeeLookupDTO) =>
          e.code.toLowerCase() === v ||
          (e.dui_person && e.dui_person.toLowerCase() === v),
      );
      return match ? toAttendanceEmployee(match) : null;
    } catch (err) {
      throw classifyApiError(err);
    }
  }

  /**
   * Card lookup stub — no remote API endpoint for card lookup (v1).
   * Always returns null; local store is authoritative for card matching.
   */
  async findByCardNumber(
    _accessRoleId: number,
    _cardNumber: string,
  ): Promise<AttendanceEmployee | null> {
    return null;
  }
}
